import * as React from 'react';
import { ClientSharedPanel, ClientSharedPanelOptions } from './SharedPanel';

const ClientPanelServiceContext = React.createContext<
  (options: ClientSharedPanelOptions) => Promise<void>
>(Promise.reject);

export const useClientPanel = () => React.useContext(ClientPanelServiceContext);
export const ClientPanelServiceProvider = ({ children }: any) => {
  const [dialogState, setDialogState] =
    React.useState<ClientSharedPanelOptions | null>(null);

  const awaitingPromiseRef = React.useRef<{
    resolve: () => void;
    reject: () => void;
  }>();

  const openConfirmation = (options: ClientSharedPanelOptions) => {
    setDialogState(options);
    return new Promise<void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (
      dialogState &&
      dialogState.catchOnCancel &&
      awaitingPromiseRef.current
    ) {
      awaitingPromiseRef.current.reject();
    }

    // onClose();
    setDialogState(null);
  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    // onClose();
    setDialogState(null);
  };

  return (
    <>
      <ClientPanelServiceContext.Provider
        value={openConfirmation}
        children={children}
      />

      <ClientSharedPanel
        open={Boolean(dialogState)}
        onSubmit={handleSubmit}
        onClose={handleClose}
        {...dialogState}
      />
    </>
  );
};
